
const KQUAKE_FDSNWS_BASE_URL = 'https://quake.kigam.re.kr/fdsnws/'


export const getMetadata = async (queryFilter, apiToken) => {
  let endpoint = KQUAKE_FDSNWS_BASE_URL + 'station/'
  let queryString = ''
  if (queryFilter.station && queryFilter.station.length > 0) {
    endpoint += 'k1/query'
    queryString = '?' + new URLSearchParams(queryFilter).toString()
  } else {
    endpoint += '1/query'
    queryString = '?' + new URLSearchParams(queryFilter).toString()
  }
  
  const config = { method: 'GET' }
  if (apiToken) {
    config.headers = {
      'X-Web-Auth-Token': apiToken,
    }
  }
  
  try {
    const response = await window.fetch(endpoint + queryString, config)
    return response
  } catch (err) {
    return {
      ok: false,
      statusText: err.message,
    }
  }
}


export const getAvailability = async (starttime, endtime, streams) => {
  let endpoint = KQUAKE_FDSNWS_BASE_URL + 'availability/k1'
  const config = {}
  if (streams.length <= 100) {
    config.method = 'GET'
    // const queryString = `/query?start=${starttime.toJSON()}&end=${endtime.toJSON()}&stream=${streams.join()}`
    const queryString = `/query?start=${starttime}&end=${endtime}&stream=${streams.join()}`
    // endpoint += encodeURIComponent(queryString)
    endpoint += queryString
  } else {
    endpoint += '/query'
    config.method = 'POST'
    config.headers = {'Content-Type': 'application/json'}
    config.body = JSON.stringify({
      // starttime: starttime.toJSON(),
      // endtime: endtime.toJSON(),
      starttime,
      endtime,
      streams,
    })
  }
  
  const response = await window.fetch(endpoint, config)
  if (response.status === 200) {
    return response.json()
  } 
  throw new Error(response.statusText)
}


export const getWavewormData = async (format, purpose, starttime, endtime, streams, apiToken) => {
  let endpoint = KQUAKE_FDSNWS_BASE_URL + 'dataselect/1/query'
  const headers = {
    'Content-Type': 'application/json',
    'X-Web-Auth-Token': apiToken,
  }

  const requests_by_stream_id = streams.map(stream_id => {return {stream_id, starttime, endtime}})

  const config = {
    method: 'POST',
    headers,
    body: JSON.stringify({
      format,
      purpose,
      // starttime: starttime.toJSON(),
      // endtime: endtime.toJSON(),
      // starttime: starttime,
      // endtime: endtime,
      // streams,
      requests_by_stream_id,
    })
  }

  // // 404는 response가 있다. (response.ok != true)
  // // ERR_CONNECTION_REFUSED(서버가 죽어있을 경우 등)은 exception이 발생해서 catch문으로 넘아간다.
  // try {
  //   const response = await window.fetch(endpoint, config)
  //   return response
  // } catch (err) {
  //   // console.error('Failed to fetch waveform data:', err)
  //   // return Promise.reject(err.message ? err.message : data)
  //   return {
  //     ok: false,
  //     statusText: (err && err.message) ? err.message : err
  //   }
  // }

  try {
    return await window.fetch(endpoint, config)
  } catch (error) {
    return {
      ok: false,
      statusText: error.message,
    }
  }
}